<template>
    <div>
        <vs-button
            shadow
            danger
            @click="refresh()"
        >
            Volver a finanzas
        </vs-button>
    </div>
</template>

<script>
export default {
    methods:{
        refresh(){
            location.reload()
        }
    }
}
</script>